import * as React from 'react';
import Button from '@mui/material/Button';
import TextField from '@mui/material/TextField';
import FormControlLabel from '@mui/material/FormControlLabel';
import Checkbox from '@mui/material/Checkbox';
import Box from '@mui/material/Box';
import { Grid } from '@mui/material';
import Typography from '@mui/material/Typography';
import Container from '@mui/material/Container';
import { useEffect, useState } from 'react'
import { useNavigate } from 'react-router-dom'
import HeaderShell from './Header/HeaderShell';
import { AuthLogin } from '../atom/actions';
import { Token, User } from '../atom/atom'
import { useRecoilState } from 'recoil';

export default function SignIn(props) {
  const [username, setUsername] = useState(null);
  const [password, setPassword] = useState(null);
  const [isAuthenticated, setIsAuthenticated] = useRecoilState(Token)
  const navigate = useNavigate()

  useEffect(() => {
    if (isAuthenticated) {
      navigate('/scenarios')
    } else {
      console.log('not authenticated in the effect', isAuthenticated)
    }
  }, [isAuthenticated])

  const handleFormFieldChange = (event) => {
    switch (event.target.id) {
      case 'username': setUsername(event.target.value); break;
      case 'password': setPassword(event.target.value); break;
      default: return null;
    }
  }

  async function login() {
    setIsAuthenticated(await AuthLogin(username, password))
  }
  const handleSubmit = (event) => {
    event.preventDefault();
    login()
  };

  return (
    <React.Fragment>
      <HeaderShell />
      <Container maxWidth="xs" sx={{ paddingTop: "4rem", justifyContent: 'center', textAlign: 'center' }}>
        <Grid container spacing={6}>
          <Grid item xs={12} sm={12} md={12}>
            <Typography variant="h1" sx={{ fontSize: { xs: "1.5rem", sm: "2rem", md: "3rem" } }}>
              Log in
            </Typography>
            <Box component="form" onSubmit={handleSubmit} noValidate sx={{ mt: 1 }}>
              <TextField
                margin="normal"
                required
                fullWidth
                id="username"
                label="Username"
                name="username"
                autoComplete="username"
                onChange={handleFormFieldChange}
                autoFocus
              />
              <TextField
                margin="normal"
                required
                fullWidth
                name="password"
                label="Password"
                type="password"
                id="password"
                autoComplete="current-password"
                onChange={handleFormFieldChange}
              />
              <FormControlLabel
                control={<Checkbox value="remember" color="primary" />}
                label="Remember me"
              />
              <Button
                type="submit"
                fullWidth
                variant="contained"
                color="secondary"
                sx={{ mt: 3, mb: 2 }}
              >
                <Typography variant="h6" color="white">Log in</Typography>
              </Button>
            </Box>
          </Grid>
        </Grid>
      </Container>
    </React.Fragment>
  );
}